export default function StatusBadge({ status }) {
  const map = {
    // Order lifecycle
    'Pending':              'badge-pending',
    'Pending Verification': 'badge-unread',
    'Processing':           'badge-confirmed',
    'Packed':               'badge-confirmed',
    'Confirmed':            'badge-confirmed',
    'Dispatched':           'badge-dispatched',
    'Delivered':            'badge-delivered',
    'Returned':             'badge-returned',
    'Cancelled':            'badge-cancelled',
    'Payment Failed':       'badge-cancelled',
    // Generic
    'Completed':            'badge-dispatched',
    'Rejected':             'badge-cancelled',
    'Unread':               'badge-unread',
    'Read':                 'badge-read',
  };
  return <span className={`badge ${map[status] || 'badge-pending'}`}>{status || '—'}</span>;
}
